import React, { createContext, ReactNode, useContext } from 'react';
import { useTenantConfig } from './GlobalDataContext';
import { TenantEnv } from 'types';
import { ServiceContainer } from 'helpers/service-provider';

interface ServiceProviderProps {
  children: ReactNode;
  services?: ServiceContainer;
}

const ServiceContext = createContext<ServiceContainer>(
  new ServiceContainer(null),
);

export const initializeServices = (
  tenantConfig: TenantEnv,
): ServiceContainer => {
  // initialize services here
  return new ServiceContainer(tenantConfig);
};

export const ServiceProvider: React.FC<ServiceProviderProps> = ({
  children,
  services,
}: ServiceProviderProps) => {
  if (!services) {
    services = initializeServices(useTenantConfig());
  }
  return (
    <ServiceContext.Provider value={services}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useServices = (): ServiceContainer => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error(
      'useServices must be inside a ServiceProvider with a state value',
    );
  }
  return context;
};
